export const enCommon = {
  // ... existing translations ...
  "welcome": "Welcome to GRUPO FR",
  "description": "Your trusted real estate partner",
  "exploreProperties": "Explore Properties",
  "ourServices": "Our Services",
  "featuredProperties": "Featured Properties",
  "aboutUs": "About Us",
  "contactUs": "Contact Us",
  "allRights": "All rights reserved",
  "propertySales": "Property Sales",
  "propertyRentals": "Property Rentals",
  "propertyManagement": "Property Management",
  "realEstateConsulting": "Real Estate Consulting",
  "propertyValuation": "Property Valuation", 
  "legalSupport": "Legal Support",
  "adminPanel": "Admin Panel",
  "language": "Language",
  
  // Search functionality
  "propertyType": "Property Type",
  "location": "Location",
  "status": "Status", 
  "forSale": "For Sale",
  "forRent": "For Rent",
  "advancedSearch": "Advanced Search",
  "priceRange": "Price Range",
  "minPrice": "Min Price",
  "maxPrice": "Max Price",
  "bedrooms": "Bedrooms",
  "bathrooms": "Bathrooms",
  "area": "Area",
  "minArea": "Min Area",
  "any": "Any",
  "reset": "Reset",
  "apartment": "Apartment",
  "house": "House",
  "condo": "Condo",
  "office": "Office",
  "commercial": "Commercial",
  
  // Compare functionality
  "compareProperties": "Compare Properties",
  "properties": "Properties",
  "characteristics": "Characteristics",
  "noPropertiesToCompare": "No properties to compare",
  "selectPropertiesToCompare": "Select properties to compare their features",
  "remove": "Remove",
  "yearBuilt": "Year Built",
  "parking": "Parking",
  "floor": "Floor",
  "furnished": "Furnished",
  "yes": "Yes",
  "no": "No", 
  "features": "Features",
  "more": "more",
  "comparingProperties": "Comparing {{count}} properties",
  "clearAll": "Clear All",
  "close": "Close",
  "addToCompare": "Add to Compare",
  "removeFromCompare": "Remove from Compare",
  "compare": "Compare",
  
  // Appointment booking
  "scheduleVisit": "Schedule Visit",
  "contactInformation": "Contact Information",
  "fullName": "Full Name",
  "enterFullName": "Enter your full name",
  "email": "Email",
  "enterEmail": "Enter your email",
  "phone": "Phone",
  "enterPhone": "Enter your phone number",
  "selectDateTime": "Select Date & Time",
  "preferredDate": "Preferred Date",
  "selectDate": "Select a date",
  "preferredTime": "Preferred Time",
  "selectTime": "Select a time",
  "additionalMessage": "Additional Message",
  "optional": "optional",
  "enterAdditionalMessage": "Enter any special requests or questions",
  "characters": "characters",
  "importantInformation": "Important Information",
  "visitDuration": "Visit duration is approximately 30-45 minutes",
  "confirmationMessage": "You will receive confirmation via email and phone",
  "cancellationPolicy": "You can cancel or reschedule with 24 hours notice",
  "cancel": "Cancel",
  "scheduling": "Scheduling...",
  "appointmentConfirmed": "Appointment Confirmed!",
  "appointmentConfirmedMessage": "Your visit has been successfully scheduled. We will contact you soon.",
  "appointmentDetails": "Appointment Details",
  "property": "Property",
  "name": "Name",
  "date": "Date",
  "time": "Time",
  "closingAutomatically": "This window will close automatically...",
  "preferVoiceAssistance": "Prefer to schedule by voice? Use our smart assistant",
  "talkWithAgent": "Talk with Agent",
  "bookVisit": "Book Visit"
};

export default enCommon;
